import { ApiAction, initialApiState, ApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'

export interface CurrentAccountTotalIntervalState extends ApiState {
  total?: number
}

const CurrentAccountTotalInterval = (state: CurrentAccountTotalIntervalState = initialApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<CurrentAccountTotalIntervalState>('CURRENT_ACCOUNT_TOTALS')(state, action)
  }
}

export default CurrentAccountTotalInterval
